export enum ProgramType {
  Movie = 'movie',
  Series = 'series',
}
